module.exports = __webpack_public_path__ + "static/media/ape-bnb.46618232.png";